import axios from 'axios';
import { URLEndpoints } from '../../constants/urlConstants';
const BASE_URL = process.env.REACT_APP_NODEJS_SERVER_URL


export const fetchSuppliersList = async (id) => {
    try {
        const res = await axios.get(`${BASE_URL}/${URLEndpoints.suppliers}`)
        console.log(res)
        return res?.data
    } catch (error) {
        console.log(error)
        return Promise.reject(error)

    }
}


export const getSingleShipping = async (id) => {
    try {
        const res = await axios.get(`${BASE_URL}/${URLEndpoints.shipping}/${id}/`)
        return res?.data
    } catch (error) {
        return Promise.reject(error)
    }
}